import React, { Component } from 'react'

class IconForm extends Component {
  render() {
    return (
      <span className="icon is-small is-left">
					<i className={this.props.styleName} />
				</span>
    )
  }
}
export default IconForm